export const TABLE_ROW_GROUPS_DROPPABLE_ID = '#root'
export const TABLE_ROW_GROUP_DRAGGABLE_TYPE = 'GROUP'
export const TABLE_ROW_DRAGGABLE_TYPE = 'ROW'
